import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/ModalBox/modal-box';
export var ModalBoxFooter = function ModalBoxFooter(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      props = __rest(_a, ["children", "className"]);

  return React.createElement("footer", Object.assign({}, props, {
    className: css(styles.modalBoxFooter, className)
  }), children);
};